/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { ContentManagementListContentResponse } from './ContentManagementListContentResponse';

export type ContentManagementListContentResponseApiRespoonse = {
    data?: ContentManagementListContentResponse;
    status?: ContentManagementListContentResponseApiRespoonse.status;
    message?: string;
    errors?: Record<string, Array<string>>;
};

export namespace ContentManagementListContentResponseApiRespoonse {

    export enum status {
        SUCCESS = 'success',
        ERROR = 'error',
    }


}

